import type fs from 'fs';
import type path from 'path';
import type perf_hooks from 'perf_hooks';
import type zlib from 'zlib';

type RequireFunction = (id: string) => any;

export interface NodeApi {
  fs: typeof fs;
  path: typeof path;
  perf_hooks: typeof perf_hooks;
  process: typeof process;
  zlib: typeof zlib;
}

// Type-safe convenience for dynamic Node module import.
export class LazyRequireNodeApi implements NodeApi {
  constructor(public require: RequireFunction) {}
  get fs(): typeof fs { return this.require('fs'); }
  get path(): typeof path { return this.require('path'); }
  get perf_hooks(): typeof perf_hooks { return this.require('perf_hooks'); }
  get process(): typeof process { return this.require('process'); }
  get zlib(): typeof zlib { return this.require('zlib'); }
}


/**
 * Make a NodeApi object from a require function obtained from an
 * AdodePanelContext or an ElectronContext.
 *
 * This function is for use in enhanced browser environments like the Adobe
 * Premiere panel and from Mimir Desktop.
 *
 * If you need a NodeApi object in a Node.js environment, you can use the
 * DirectNodeApi class from common/src/nodejs/directNodeApi.ts instead.
 */
export function getNodeApi(requireFunction: (id: string) => any): NodeApi {
  return new LazyRequireNodeApi(requireFunction);
}
